(function(app) {
    app.constant("householdRelationshipTypes",
    [
        "Spouse",
        "Sibling",
        "Parent",
        "Child",
        "Other",
        "Grandparent",
        "Grandchild",
        "SiblingChild",
        "ParentSibling"
    ]);
})(window.app); //jshint ignore:line